import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import { CreateNotificationPayload } from '../request/notification-push';
import { GetNotificationsResponse } from '../response/notification-push';

export class NotificationService {
  static getNotifications(params?: QueryParams) {
    return apiClient.get<GetNotificationsResponse>(buildApiUrl('/api/v1/admin-config/notifications'), params);
  }

  static createNotification(payload: CreateNotificationPayload) {
    return apiClient.post<void>(buildApiUrl('/api/v1/admin-config/notifications'), payload);
  }
}
